module.exports = __webpack_public_path__ + "img/1F.a13009b5.png";